import { Component, Input } from '@angular/core';
import { Banner } from '@motivforce/mx-library-angular';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  @Input() banner: Banner;
  @Input() showLogo = false;
}
